import { tagDefinitionsReportHasAppliedUsage } from "./tagDefinitionsReportApplied";

/** Shown on Budget and Stripboard to explain production-tag prerequisites for AI. */
export const SCHEDULE_BUDGET_TAGS_EDUCATION =
  "Schedule and budget need script tags. Run Script breakdown in Run AI to add them.";

export function shouldShowScheduleBudgetTagsEducation(args: {
  hasLoadedTagReport: boolean;
  rows: Array<{ scene_count?: number }> | undefined;
  /** A completed schedule or budget no longer needs prerequisite education. */
  hasCompletedOutput?: boolean;
  /** While a refetch is in flight, keep the banner hidden so a stale empty report does not flash. */
  isTagReportFetching?: boolean;
}): boolean {
  if (args.hasCompletedOutput) {
    return false;
  }
  if (tagDefinitionsReportHasAppliedUsage(args.rows)) {
    return false;
  }
  if (!args.hasLoadedTagReport) {
    return false;
  }
  if (args.isTagReportFetching) {
    return false;
  }
  return true;
}
